import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Chip,
  Grid,
  Button,
  IconButton,
} from "@mui/material";
import { useSelector } from "react-redux";
import SelectableRadioGroupManager from "../../../selectable-radio-group-manger";
import MicIcon from "@mui/icons-material/Mic";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const strategies = ["Safe", "Disappointed", "Happy", "Sad", "Proud", "Let Down", "Angry", "Unhappy"];

const PersonDebriefManager = ({ nextStep, witnessData, debriefData }) => {
  const user = useSelector((state) => state.auth.user); // User data from Redux store

  const allowedBehaviors = debriefData?.map((b) => b.behavior);

  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Chip
        variant='contained'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "blue",
        }}
        label='Daily Log'
        size='small'
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>
        Child and Young Person Debrief
      </Typography>
      <Typography variant='subtitle2' sx={{ color: "#757575" }}>
        Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
        <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>
      <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item lg={8}>
          <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "#333", mb: 2 }}>
            How Do you feel about the physical intervention?
          </Typography>

          <SelectableRadioGroupManager options={strategies} allowedOptions={allowedBehaviors} />

          <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "#333", mb: 2, mt: 3 }}>
            Witness / Involved in search
          </Typography>

          {/* Table */}
          <Grid container>
            <Grid item lg={6}>
              <TableContainer component={Paper} elevation={3}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#E3F2FD" }}>
                      <TableCell sx={{ fontWeight: "bold", color: "#1976D2" }}>Name</TableCell>
                      <TableCell sx={{ fontWeight: "bold", color: "#1976D2" }}>Involved</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {witnessData?.map((witness, index) => (
                      <TableRow key={index}>
                        <TableCell>{witness.name}</TableCell>
                        <TableCell>{witness.role}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <br />
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={4} md={4}>
          {/* Incident Management Details Section - Recorded Entries */}
          <Box sx={{ mt: 4 }}>
            <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold", mb: 2 }}>
              Incident Management
            </Typography>
            <Typography sx={{ fontSize: "14px", mb: 3 }}>Behavior Records</Typography>

            {debriefData?.map((record, index) => (
              <Paper
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: 1,
                  mb: 1,
                  borderRadius: 2,
                  border: "1px solid #ccc",
                }}
              >
                <Typography sx={{ fontSize: "14px", color: "black" }}>
                  {record.audio ? (
                    record.behavior
                  ) : (
                    <>
                      {record.behavior}
                      <br />
                      {record.note}
                    </>
                  )}
                </Typography>

                <Box>
                  {record.audio && (
                    <>
                      <IconButton onClick={() => window.open(record.audio, "_blank")}>
                        <MicIcon color='primary' />
                      </IconButton>
                      <IconButton onClick={() => window.open(record.audio, "_blank")}>
                        <CloudDownloadIcon color='primary' />
                      </IconButton>
                    </>
                  )}
                </Box>
              </Paper>
            ))}
          </Box>
        </Grid>
      </Grid>

      {/* Footer Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          position: "sticky",
          bottom: 0,
          background: "#fff",
          padding: 2,
          zIndex: 10,
        }}
      >
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            nextStep(); // Call the function properly
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default PersonDebriefManager;
